import { User } from './user';

export class UnitOfMeasure {
  symbol!: string;
  name!: string;
  description?: string;
  tonnage_fraction!: number;
  status!: string;
  user_uuid!: string;
  date_deleted?: number;
  uuid!: string;
  date_created!: number;
  date_updated!: number;

  user?: User;
  parentCategory?: UnitOfMeasure;

  static getSortColumns() {
    return [
      'name',
      'symbol',
      'description',
      'status',
    ];
  }


  constructor(data: any) {
    this.user_uuid = data.user_uuid;
    this.name = data.name;
    this.symbol = data.symbol;
    this.description = data.description;
    this.tonnage_fraction = data.tonnage_fraction;
    this.status = data.status;
    this.date_deleted = data.date_deleted;
    this.uuid = data.uuid;
    this.date_created = data.date_created;
    this.date_updated = data.date_updated;

    if (data.user) {
      this.user = new User(data.user);
    }
  }
}
